import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { ArrowForward } from "@material-ui/icons";
import { IntegerInput } from "components/Global/FormikMaterial";

import { dealGetWithSubkey } from "../../../../pages/dealSettings/dealSettings.store";
import "./styles.css";

const DealSearchField = props => {
  const {
    setFieldValue,
    values: formikValues,
    dealGetWithSubkey,
    setDealId,
    setSubmitted
  } = props;

  return (
    <div className="test-harness-deal-search">
      <span>Deal ID: </span>
      <span>
        <IntegerInput
          value={formikValues.dealId}
          onChange={e => {
            setFieldValue("dealId", e.target.value);
          }}
        />
      </span>
      <span>
        <button
          style={{ cursor: "pointer", backgroundColor: "rgba(0,0,0,0)", border: "none", paddingTop: "2px" }}
          onClick={() => {
            setDealId(formikValues.dealId);
            setSubmitted(false);
            dealGetWithSubkey({ dealId: formikValues.dealId });
          }}
        >
          <ArrowForward />
        </button>
      </span>
    </div>
  );
};

const mapStateToProps = ({ dealSettings }) => ({
  ...dealSettings
});

export default compose(
  connect(
    mapStateToProps,
    { dealGetWithSubkey }
  )
)(DealSearchField);
